/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useEffect } from "react";
import DOMPurify from "dompurify";
import superagent from "superagent";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "universal-cookie";
import useTimeCounter from "./hooks/useTimeCounter";
import { base_url } from "../../utils/constants";
import { DELETE_ANNOUNCEMENT, SHOW_ANNOUNCEMENT } from "../../containers/admin/addAnnouncement/redux/constants";
import { addTargetBlank, preventPropogation } from "../../utils/commonFunctions";
import MobileAnnouncementBar from "./MobileAnnouncementBar";
import { getUserInfo } from "../../store/selector/userSelector";
import { getExpiredAnnouncements } from "../../containers/admin/addAnnouncement/redux/action";
import TimerCounter from "./TimerCounter";

const cookie = new Cookies();

function AnnouncementBar({ activeAnnouncement, setShowAnnouncement, loggedIn }) {
  const dispatch = useDispatch();
  const userInfo = useSelector(getUserInfo);
  const handlecloseAnnouncement = useCallback(
    async (e) => {
      e.stopPropagation();
      if (userInfo?.role === "Admin") {
        dispatch({ type: SHOW_ANNOUNCEMENT, payload: false });
        setShowAnnouncement(false);
      } else {
        if (loggedIn) {
          await superagent.post(`${base_url}save-user-announcement`).set("Authorization", cookie.get("user_token"));
        } else {
          sessionStorage.setItem("hideAnnouncement", true);
        }
        dispatch({ type: DELETE_ANNOUNCEMENT });
        dispatch({ type: SHOW_ANNOUNCEMENT, payload: false });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loggedIn, setShowAnnouncement],
  );

  const endTimerCallback = () => {
    dispatch({ type: DELETE_ANNOUNCEMENT });
    dispatch(getExpiredAnnouncements());
  };

  useEffect(() => {
    addTargetBlank("announcement-bar");
    preventPropogation("prevent-propogation-class");
  }, []);

  const handleClick = (e) => {
    e.stopPropagation();
    if (activeAnnouncement?.link) {
      window.open(activeAnnouncement?.link?.startsWith("www.") ? `https://${activeAnnouncement?.link}` : activeAnnouncement?.link, "_blank");
    }
  };

  const { seconds, minutes, hours, days } = useTimeCounter(activeAnnouncement.date, activeAnnouncement.time, endTimerCallback);

  return (
    <>
      <MobileAnnouncementBar
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
        activeAnnouncement={activeAnnouncement}
        handlecloseAnnouncement={handlecloseAnnouncement}
      />

      <div
        className={`announcement-bar ps-2 py-2 pe-5 d-lg-flex d-none align-items-center justify-content-center ${
          activeAnnouncement?.link ? "cursor-pointer" : null
        }`}
        style={{ background: activeAnnouncement.color }}
        onClick={handleClick}
      >
        <i className="fa-solid fa-xmark position-absolute top-50 end-0 translate-middle-y p-3 cursor-pointer" onClick={handlecloseAnnouncement} />
        <div
          className="text-lg me-3 announcement-inner prevent-propogation-class overflow-hidden"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(activeAnnouncement.announcement?.replaceAll("</p><p>", " ").replace(/<br>/g, "")),
          }}
        />
        {activeAnnouncement.timer ? <TimerCounter seconds={seconds} minutes={minutes} hours={hours} days={days} /> : null}
      </div>
    </>
  );
}

export default AnnouncementBar;
